function getEnv(key) {
  if (typeof window !== "undefined" && window._env_ && key in window._env_) {
    return window._env_[key];
  }
  if (typeof process !== "undefined" && process.env && process.env[key]) {
    return process.env[key];
  }
  return undefined;
}

/** Slack Incoming Webhook URL; set in public/config.js or REACT_APP_SLACK_WEBHOOK_URL at build time. */
export const slackWebhookUrl = getEnv("REACT_APP_SLACK_WEBHOOK_URL") || "";
